const debugConfiguration = {
    enable: false,
    skipInitializeApplication: false,
    skipCheckOwnerAddress: true,
    skipSubmitService: true,
};

/**
 * The project contains quite a few long scenarios. For example, creating a service requires many complex steps. This class allows you to skip some steps and replace real data with mock data, which simplifies development.
 */
export class Debug {
    static get skipInitializeApplication() {
        return debugConfiguration.enable && debugConfiguration.skipInitializeApplication;
    }

    static get skipCheckOwnerAddress() {
        return debugConfiguration.enable && debugConfiguration.skipCheckOwnerAddress;
    }

    static get skipSubmitService() {
        return debugConfiguration.enable && debugConfiguration.skipSubmitService;
    }
}
